import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo from './logo.png'

export default function Navbar(props) {

    return (
        <div>
            
            <nav className={`navbar navbar-expand-lg ${props.mode === 'dark' ? 'bg-dark navbar-dark text-white border-light' : 'bg-light navbar-light text-dark border-dark'} shadow-lg`}>
                <div className="container ps-5 pe-5">
                    <h5><img src={logo} alt="Text Utils" className='' width={'45em'}/></h5>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-5  ">
                            <li className="nav-item">
                                <Link className="nav-link active ps-5" aria-current="page" to="/Text-Utils">Home</Link>
                            </li>
                            <li className="nav-item ps-3">
                                <Link className="nav-link" to="/about">{props.about}</Link>
                            </li>
                        </ul>
                    </div>
                    <button className='btn d-flex justify-content-center align-content-center' onClick={props.toggleMode} title={`${props.mode}`}>
                        <i className={`bx ${props.mode === 'dark' ? 'bx-moon' : 'bx-sun'} fs-4 p-1 ${props.mode === 'dark' ? 'text-light' : 'text-dark'}`}></i>
                    </button>
                </div>
            </nav>
        </div>
    );
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    about: PropTypes.string.isRequired,
    toggleMode: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
};
